// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"w8-z"};